import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EVENTO, GridDataSource, LoaderService, NotificationService } from 'src/app/shared/session';
import { RolParametroAutonomiaService } from '../shared/rol-parametro-autonomia.service';
import { RolParametroAutonomia } from '../shared/rol-parametro-autonomia.model';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { SessionInfo } from 'src/app/shared/session/SessionInfo';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-rol-parametro-autonomia-list',
  templateUrl: './rol-parametro-autonomia-list.component.html',
})
export class RolParametroAutonomiaListComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() titlePage: string;
  @Input() data: any;

  displayedColumns: string[] = ['parametro', 'valorMin', 'valorMax'];
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;

  constructor(private loaderService: LoaderService,
    private rolParametroAutonomiaService: RolParametroAutonomiaService,
    private notificationService: NotificationService,
    private sessionInfo: SessionInfo,
  ) { }

  ngOnInit() {
    this.msgErrorGet = 'Error al listar los parametros de autonomia por rol';
  }

  searchEmit(data: any) {
    this.buscarRolParametroAutonomia(data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  buscarRolParametroAutonomia(filtro: string) {
    this.listarRolParametroAutonomia(filtro);
  }

  listarRolParametroAutonomia(filtro: string): void {
    this.loaderService.show();
    this.rolParametroAutonomiaService.listarRolParametroAutonomia(filtro, this.data.rol.ID)
      .subscribe(res => {
        this.dataSource = new GridDataSource(res);
        this.showHideMessageGridEmpty(Number(res.length));
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }

  handleRowClick(row: any) {
    this.data = {
      idRol: row.idRol, idParametroAutonomia: row.idParametroAutonomia, parametro: row.parametro,
      rol: { ID: row.idRol, Name: row.rol },
    };
    this.changeEvent({ evento: EVENTO.guardarAutonomia, data: this.data });
  }

  async generarResumenAutonomia() {
    this.loaderService.show();
    try {
      let list: RolParametroAutonomia[] = await this.rolParametroAutonomiaService.listarRolParametroAutonomia('', null).toPromise();
      this.generarPdf(list);
    } catch (error) {
      this.notificationService.error('Error al generar resumen autonomia');
      throw error;
    } finally {
      this.loaderService.hide();
    }
  }

  generarPdf(data: any[]) {
    const content: any[] = [];

    content.push({
      text: 'Resumen Autonomia',
      style: 'title',
      alignment: 'center'
    });

    content.push({
      text: `${this.sessionInfo.getEmpresaName()}`,
      style: 'subTitle',
    });

    const groupedByRol = data.reduce((acc, item) => {
      if (!acc[item.idRol]) {
        acc[item.idRol] = {
          rol: item.rol,
          items: []
        };
      }
      acc[item.idRol].items.push(item);
      return acc;
    }, {} as Record<number, { rol: string; items: any[] }>);

    Object.keys(groupedByRol).forEach((idRol) => {
      const grupo = groupedByRol[idRol];

      content.push({
        text: `${grupo.rol}`,
        style: 'header'
      });

      const tableBody = [
        [
          { text: 'Parámetro', style: 'tableHeader' },
          { text: 'Valor Mínimo', style: 'tableHeader' },
          { text: 'Valor Máximo', style: 'tableHeader' }
        ]
      ];

      grupo.items.forEach(item => {
        tableBody.push(
          [
            { text: item.parametro, style: 'tableContent' },
            { text: item.valorMin != null ? item.valorMin.toFixed(2) : '-', style: 'tableContent' },
            { text: item.valorMax != null ? item.valorMax.toFixed(2) : '-', style: 'tableContent' }
          ]
        );
      });

      content.push({
        table: {
          widths: ['*', 'auto', 'auto'],
          body: tableBody
        },
        margin: [0, 5, 0, 5]
      });
    });

    const documentDefinition: any = {
      pageSize: 'A4',
      pageMargins: [20, 20, 20, 30],
      content,
      footer: function (currentPage: number, pageCount: number) {
        return {
          text: `${currentPage}/${pageCount}`,
          alignment: 'right',
          margin: [0, 0, 20, 0],
          fontSize: 9
        };
      },
      styles: {
        header: {
          fontSize: 11,
          bold: true,
          margin: [0, 5, 0, 5]
        },
        tableHeader: {
          fontSize: 11,
          bold: true,
          fillColor: '#eeeeee'
        },
        tableContent: {
          fontSize: 11,
        },
        title: {
          fontSize: 13,
          bold: true,
          margin: [5, 5, 5, 5],
        },
        subTitle: {
          fontSize: 12,
          margin: [0, 5, 0, 5],
        }
      }
    };

    pdfMake.createPdf(documentDefinition).download(`Resumen_Autonomia_${this.sessionInfo.getEmpresaName()}.pdf`);
  }
}
